import { useSession } from '../App.jsx';

/**
 * The company being worked on, as a query fragment for the document lists.
 * The switcher in the top bar puts the chosen company first in the session.
 */
export function useEntityQuery() {
  const entity = useSession().entities[0];
  return entity ? `entity_id=${entity.id}` : '';
}
